import { getCookie, setCookie } from '@utils/cookie.js'
import http from '../../utils/http.js'
import { newsletterSignupPopup } from '@modules/popups/newsletter.js'
import { trackEvent } from '@modules/tracking/tracking.js'
import { useCityStore } from '@store/city.js'
import { useUserStore } from '@store/user.js'
;(async function () {
    const guideElement = document.querySelector('.article-profile')
    const cityStore = useCityStore()
    const userStore = useUserStore()

    if (guideElement) {
        if (userStore.isLoggedIn || getCookie('thatsup_hide_newsletter_popup') === 'true') {
            return
        }

        const openPopupAfterSeconds = 90

        const openPopup = async () => {
            const isDialogOrSearchOpen =
                document.querySelector('html.search-autocomplete-open') ||
                document.querySelector('dialog[open]')
            if (isDialogOrSearchOpen) {
                window.setTimeout(() => {
                    openPopup()
                }, 5000)
                return
            }

            let response = null
            try {
                response = await http.get('/newsletter/?city=' + cityStore.currentCity.code)
            } catch (e) {
                return
            }
            const { id, name, description } = response.data

            trackEvent('popup_open', {
                category: 'newsletter',
                nonInteraction: true,
            })

            newsletterSignupPopup({ id, title: name, description }).then((subscribed) => {
                setCookie('thatsup_hide_newsletter_popup', true, subscribed ? 365 : 7)

                if (subscribed) {
                    trackEvent('subscribed', {
                        category: 'newsletter',
                    })
                }
            })
        }

        setTimeout(() => {
            openPopup()
        }, 1000 * openPopupAfterSeconds)
    }
})()
